// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__minervaModern_bf375f', '__minervaModern_Fallback_bf375f'"},"className":"__className_bf375f","variable":"__variable_bf375f"};